/* eslint tailwindcss/no-custom-classname: off */
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  RootState,
  initialHeaderState,
  setOpen,
  AppDispatch,
  useGetUserInfoQuery,
} from '@/stores'
import { setReferrer } from '@/stores/referrerSlice'
import { isDevelopment } from '@/utils/env'
import { Header } from '../Header'
import { ModalBackdrop } from '../Modal/ModalBackdrop'
import { LoginError } from '../Modal/LoginError'
import { Footer } from '../Footer/Footer'
import { LoginForm } from '../LoginForm'
import { TopLoadingBar } from './TopLoadingBar'
import { IeModal } from '../Modal'
import { postGetSession } from '@/api/user'
import { TutorialModal } from '../Modal/TutorialModal'
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './ErrorFallback'

interface Props {
  children?: React.ReactNode
}

export const Layout: React.FC<Props> = ({ children }) => {
  useGoogleAnalytics()

  const router = useRouter()
  const dispatch = useDispatch<AppDispatch>()
  const previousUrl = useSelector((state: RootState) => state.referrer.url)
  const { data: user, refetch } = useGetUserInfoQuery()

  useEffect(() => {
    // 旧フロントからのログイン状態を引き継ぐため、PHPSESSIDでAPI_KEY, SECRETを取得し保存
    ;(async () => {
      await postGetSession()
      refetch()
    })()
  }, [user])

  // URLが変わるたびに実行
  useEffect(() => {
    // flier_access_log.jsonに記録するためreferrerを保持しておく
    dispatch(setReferrer(router.asPath))

    // flier_access_log.jsonに記録
    const referrer = previousUrl
      ? `${process.env.WWW_SERVER}${previousUrl}`
      : document.referrer
    const requestPath = router.asPath
    const body = { referrer, requestPath }

    if (!isDevelopment() && !location.href.includes('preview-pr')) {
      fetch('/access_log', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(body),
      })
    }
  }, [router.asPath])

  const handleClick = () => {
    dispatch(setOpen(initialHeaderState.open))
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div onClick={handleClick}>
        <TopLoadingBar />
        <Header />
        <section>
          <div className="overall">{children}</div>
        </section>
        <Footer />
        <LoginForm />
        <ModalBackdrop />
        <LoginError />
        <IeModal />
        <TutorialModal />
      </div>
    </ErrorBoundary>
  )
}
